import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //PRBottlerSelection REDUX part
  PRbottlerData: [],
  PRtransformedTreeData: [],
  PRselectedTreeIds: [],
  PRfinalTreeData: [],
  PRfilterApplied: false,
};

const PREntityTree = createSlice({
  name: "PRentity",
  initialState,
  reducers: {
    setPRBottlerData: (state, action) => {
      state.PRbottlerData = action.payload;
    },
    setPRTransformedTreeData: (state, action) => {
      state.PRtransformedTreeData = action.payload;
    },
    setPRSelectedTreeIds: (state, action) => {
      state.PRselectedTreeIds = action.payload;
    },
    setPRFinalTreeData: (state, action) => {
      state.PRfinalTreeData = action.payload;
    },
    setPRFilterApplied: (state, action) => {
      state.PRfilterApplied = action.payload;
    },
  },
});

export const {
  setPRBottlerData,
  setPRTransformedTreeData,
  setPRSelectedTreeIds,
  setPRFinalTreeData,
  setPRFilterApplied,
} = PREntityTree.actions;
export default PREntityTree.reducer;
